import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=ab7b5392&scoped=true&"
var script = {}
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=ab7b5392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7b5392",
  null
  
)

export default component.exports